
import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    contetnArrange: {
        backgroundColor:'#fff',
        width: '100%',
        padding: '10px 20px',
        position:'fixed',
        display: 'flex',
        bottom: '0',
        left:'0',
        right:'0',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        color: '#aaa',
        borderTop: 'solid 1px #ddd',
        '& a': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color:'#aaa',
            '&:hover':{
                textDecoration: 'none',
                backgroundColor:'#532550',
                padding: '10px',

            }
            
        }
    }
}));

export default style;
